module.exports = __webpack_public_path__ + "img/right-arrow-disable.1dd374a4.svg";